module.exports = __webpack_public_path__ + "img/menu_play_sp.f6143369.png";